import React, { Component } from "react";
import { Tabs, Tab } from 'react-bootstrap';

import axios from '../../../axios';
import { getCookie, isTruthyValue } from '../../../function';
import Dmi from "../../../component/settings/dmi/dmi";
import IMAP from "../../../component/settings/imap/imap";
import SMTP from "../../../component/settings/smtp/smtp";
import Domain from "../../../component/settings/domain/domain";
import Company from "../../../component/settings/company/company";
import Profile from "../../../component/settings/profile/profile";
import Password from "../../../component/settings/password/password";
import Ransomware from '../../../component/settings/ransomware/ransomware';
import BotDetection from "../../../component/settings/bot-detection/bot-detection";
// import CampaignExpired from "../../../component/settings/campaign-expired/campaign-expired";
import CompanyIntegration from "../../../component/company-integration/company-integration";
import Deepfake from "../../../component/settings/deepfake/deepfake";

import './settings.css'

export default class SettingTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tab: null,
            userAgent: getCookie('userAgent'),
            permissibleActionsIAM: {}
        };
        this.isTAconnected = getCookie('isTAconnected')
    }
    componentDidMount = () => {
        this.loadPermissibleActions();
    }
    useQuery = () => {
        return new URLSearchParams(window.location.search);
    }
    nextPath = (path) => {
        this.props.history.push(path);
    }
    loadPermissibleActions = async () => {
        try {
            let permissibleActions = await axios.post('/api/iam-user/permissions', {
                actions: ['setting-write', 'setting-delete']
            });
            this.setState({ permissibleActionsIAM: permissibleActions.data.permissibleObj });
        } catch (error) {
            console.log("Error occured while fetching permissibleActionsIAM: ", error);
        }
    }

    render() {
        var tab = this.state.tab ? this.state.tab : this.useQuery().get('tab') ? this.useQuery().get('tab') : 'profile';
        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">Settings</h4>
                            </div>
                        </div>
                        <div className="col-md-8"> </div>
                    </div>
                </div>
                <div className="page-content tab-setting" id="tab-wrapper">
                    <Tabs activeKey={tab} onSelect={(k) => { this.setState({ tab: k }, () => this.props.history.push(`/settings/?tab=${k}`)) }} id="uncontrolled-tab-example">
                        <Tab eventKey="profile" title="Profile">
                            <Profile nextPath={this.nextPath}></Profile>
                        </Tab>
                        <Tab eventKey="company" title="Company">
                            <Company permissibleActionsIAM={this.state.permissibleActionsIAM}></Company>
                        </Tab>
                        {!this.isTAconnected &&
                            <Tab eventKey="authentication" title="Security">
                                <Password></Password>
                            </Tab>
                        }
                        {/* <Tab eventKey="campaign-expired" title="Campaign">
                            <CampaignExpired permissibleActionsIAM={this.state.permissibleActionsIAM}></CampaignExpired>
                        </Tab> */}
                        {this.state.userAgent &&
                            <Tab eventKey="ransomware" title="Ransomware">
                                <Ransomware permissibleActionsIAM={this.state.permissibleActionsIAM}></Ransomware>
                            </Tab>
                        }
                        <Tab eventKey="domain" title="Domains">
                            <Domain permissibleActionsIAM={this.state.permissibleActionsIAM}></Domain>
                        </Tab>
                        <Tab eventKey="dmi" title="DMI">
                            <Dmi permissibleActionsIAM={this.state.permissibleActionsIAM}></Dmi>
                        </Tab>
                        <Tab eventKey="advanced" title="SMTP">
                            <SMTP permissibleActionsIAM={this.state.permissibleActionsIAM}></SMTP>
                        </Tab>
                        <Tab eventKey="imap" title="IMAP">
                            <IMAP permissibleActionsIAM={this.state.permissibleActionsIAM}></IMAP>
                        </Tab>
                        <Tab eventKey="api-token" title="API Token">
                            <CompanyIntegration permissibleActionsIAM={this.state.permissibleActionsIAM}></CompanyIntegration>
                        </Tab>
                        <Tab eventKey="bot-detection" title="Bot Detection">
                            <BotDetection permissibleActionsIAM={this.state.permissibleActionsIAM}></BotDetection>
                        </Tab>
                        {isTruthyValue(getCookie("isDeepFakeEnabled")) && 
                            <Tab eventKey="deep-fake" title="AI Voice Manager">
                                <Deepfake permissibleActionsIAM={this.state.permissibleActionsIAM}></Deepfake>
                            </Tab>
                        }
                    </Tabs>
                </div>
            </div>
        );
    }
}
